import throttle from "lodash.throttle";
import { EVENTS } from "../../constants";

export default class ScrollObserver {
  /**
   * @param {HTMLElement} element
   * @param {boolean} isThrottled
   * @param {number} delay
   */
  constructor(element, isThrottled = true, delay = 50) {
    this.element = element;
    this.isThrottled = isThrottled;
    this.delay = delay;

    // Set correct scope for callbacks
    this._onScroll = this._onScroll.bind(this);
    this._handleScroll = this._handleScroll.bind(this);

    // Add scroll event listener
    this.element.addEventListener("scroll", this._onScroll());
  }

  /**
   * call `_handleScroll()` via throttle is `isThrottled` is true
   *
   * @private
   * @returns {Function}
   */
  _onScroll() {
    return this.isThrottled
      ? throttle(this._handleScroll, this.delay)
      : this._handleScroll;
  }

  /**
   * dispatch `SCROLLED` event
   */
  _handleScroll() {
    this.element.dispatchEvent(new CustomEvent(EVENTS.SCROLLED));
  }
}
